import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {
  AppPageComponent,
  AppSidenavComponent,
  AppBarComponent,
  AppBarTitleComponent,
  AppBarExpandedTabsComponent
} from 'common';
import { appPageComponentDataMaster } from '../../app.data';
import { UserMenuComponent } from '../../user/user-menu/user-menu.component';
import { FeatureFlagListResolver } from './feature-flag.resolver';
import { AppPageResolver, AppSidenavResolver } from '../../app.resolver';
import { AdminAppBarExpandedTabsResolver } from '../admin.resolver';
import { FeatureFlagListComponent } from './feature-flag-list/feature-flag-list.component';
import { BOAuthGuard } from '../../guards/oauth.guard';

const appPageDataMaster = appPageComponentDataMaster({
  appBarTitle: 'Admin',
  sideNavItem: 'admin'
});

const routes: Routes = [
  {
    path: '',
    canActivate: [BOAuthGuard],
    children: [
      {
        path: 'admin/features',
        component: AppPageComponent,
        data: appPageDataMaster,
        resolve: {
          appBarExpandedTabs: AdminAppBarExpandedTabsResolver,
          appPage: AppPageResolver,
          appSidenav: AppSidenavResolver
        },
        children: [
          {
            path: '',
            outlet: 'sidenav-content',
            component: AppSidenavComponent
          },
          {
            path: '',
            component: AppBarComponent,
            outlet: 'app-bar',
            children: [
              {
                path: '',
                outlet: 'title',
                component: AppBarTitleComponent,
              },
              {
                path: '',
                outlet: 'right',
                component: UserMenuComponent,
              },
              {
                path: '',
                outlet: 'expanded',
                component: AppBarExpandedTabsComponent
              }
            ]
          },
          {
            path: '',
            component: FeatureFlagListComponent,
            runGuardsAndResolvers: "paramsOrQueryParamsChange",
            resolve: {
              featureFlagListResult: FeatureFlagListResolver
            }
          }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FeatureFlagRoutingModule { }
